<template>
  <button class="btn btn-info" @click.prevent="add()">
    <i class="fa fa-fw fa-plus"></i>
    <slot>Dodaj wiersz</slot>
  </button>
</template>

<script>
export default {
  name: 'w-add-row',
  props: {
    model: {
      type: Object,
      required: true
    },
    count: {
      type: Number,
      default: 1
    }
  },
  methods: {
    add() {
      this.model.$addRow({}, this.count);
      this.$emit('rowAdded', this.count);
    }
  }
};
</script>
